import { useExperiments } from '@wix/fe-essentials-standalone';
import { useRouter } from 'next/router';

import { useResponsive } from './useResponsive';
import { EXPERIMENTS, LOCALES } from '../constants';
import { useStore } from '../zustand/stores';

const useIsArticlePageRedesignUnifiedUXEnabled = () => {
  const { experiments } = useExperiments({ readOnly: true });
  const { locale } = useRouter();
  const { isMobile } = useResponsive();
  const { user } = useStore((state) => state.userSlice);

  return (
    experiments.enabled(EXPERIMENTS.SPECS.ARTICLE_PAGE_REDESIGN_UNIFIED_UX) &&
    locale === LOCALES.EN &&
    !isMobile &&
    user !== null
  );
};

export default useIsArticlePageRedesignUnifiedUXEnabled;
